export default {
  signerAuths: [],
  signerSignAs: [],
  newSignerSignAs: [],
  communicateBy: [],
  contacts: [],
  links: {},
};
